<template>
    <v-card>
        <v-card-text>
            <v-layout>
                <v-flex xs12>
                    <v-alert type="error" v-model="error_alert">{{ err_msg }}</v-alert>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs8 offset-xs2 sm6 offset-xs3>
                    <v-text-field name="po_number" v-model="po_search" required :rules="[rules.required]" label="PO# Lookup" @keyup.enter="searchPO()" @click:append-outer="searchPO" dense append-outer-icon="fa-search"></v-text-field>
                </v-flex>
            </v-layout>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            <v-layout row v-if="items.length > 0">
                <v-flex xs12>
                    <v-card class="mb-4">
                        <v-card-title class="primary white--text">
                            <h2>PO# {{ items[0].POHeader.PONumber }}</h2>
                        </v-card-title>
                        <v-card-text class="card-with-table">
                            <p v-if="items[0].POHeader.CONumber">CO# : {{ items[0].POHeader.CONumber }}</p>
                            <p v-if="items[0].POHeader.OrderDate">Order Date : {{ items[0].POHeader.OrderDate }}</p>
                            <p>Address:<br>
                                {{ items[0].POHeader.ShipToAddress1 }}<br v-if="items[0].POHeader.ShipToAddress1" />
                                {{ items[0].POHeader.ShipToAddress2 }}<br v-if="items[0].POHeader.ShipToAddress2" />
                                {{ items[0].POHeader.ShipToAddress3 }}<br v-if="items[0].POHeader.ShipToAddress3" />
                                {{ items[0].POHeader.ShipToAddress4 }}<br v-if="items[0].POHeader.ShipToAddress4" />
                                {{ items[0].POHeader.ShipToCity }}, {{ items[0].POHeader.ShipToState }} {{ items[0].POHeader.ShipToZiip }} {{ items[0].POHeader.ShipToCountry }}
                            </p>
                            <table class="line-item-table">
                                <tr>
                                    <th class="text-xs-left">#</th>
                                    <th class="text-xs-left">Item</th>
                                    <th class="text-xs-left">Cust Item#</th>
                                    <th>Qty Ordered</th>
                                    <th>Release Date</th>
                                    <th>Est. Ship Date</th>
                                    <th>Qty Shipped</th>
                                    <th>Ship Date</th>
                                    <th>Carrier</th>
                                    <th>Tracking</th>
                                </tr>
                                <tr v-for="(line_item, key) in items[0].POLineItems" :key="key">
                                    <td class="small">{{ line_item.Line }}</td>
                                    <td class="main-field">{{ line_item.Item }}<br>{{ line_item.Description }}</td>
                                    <td class="main-field">{{ line_item.CustomerItem }}</td>
                                    <td>{{ line_item.QtyOrdered }}</td>
                                    <td>{{ formatDate(line_item.OrderDate) }}</td>
                                    <td>{{ formatDate(line_item.EstimatedShipDate, "Pending") }}</td>
                                    <td>{{ line_item.QtyShipped }}</td>
                                    <td>{{ formatDate(line_item.ShipDate) }}</td>
                                    <td>{{ line_item.Carrier }}</td>
                                    <td class="tracking-column text-xs-left">
                                        <a v-if="has_tracking_link(line_item.Carrier, line_item.TrackingNumber)" target="tracking" :href="get_tracking_link(line_item.Carrier, line_item.TrackingNumber)">{{ line_item.TrackingNumber }}</a>
                                        <span v-else-if="line_item.TrackingNumber != null">{{ line_item.TrackingNumber }}</span>
                                        <span v-else-if="pastEstimatedShipDate(line_item.EstimatedShipDate)">Contact <a href="mailto:customerservice@tutco.com">customerservice@tutco.com</a> for info.</span>
                                        <span v-else>Tracking will be available once your order has shipped.</span>
                                    </td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <h3 class="grey--text" v-if="items.length > 0">Other orders associated with this account from past 90 days. <span>({{ filtered_items.length }} Results)</span></h3>
            <v-data-table v-if="filtered_items.length > 0" ref="dataTable" expand :expanded="open" :headers="headers" :items="filtered_items" :pagination.sync="pagination" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr @click="expandItem(props)">
                        <td class="text-xs-center hide-column">
                            <v-btn flat fab small>
                                <v-icon v-if="!props.expanded">fa-caret-right</v-icon>
                                <v-icon v-if="props.expanded">fa-caret-down</v-icon>
                            </v-btn>
                        </td>
                        <td class="text-xs-left po-number">
                            {{ props.item.POHeader.PONumber }}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.POHeader.ShipToAddress1 }}, {{ props.item.POHeader.ShipToAddress2 }}, {{ props.item.POHeader.ShipToCity }} {{ props.item.POHeader.ShipToState }}
                        </td>
                    </tr>
                </template>
                <template slot="expand" slot-scope="props">
                    <v-layout row>
                        <v-card class="flex xs12 pa-3 mb-4">
                            <v-card-title class="primary white--text">
                                <h4>PO# {{ props.item.POHeader.PONumber }}</h4>
                            </v-card-title>
                            <v-card-text class="card-with-table">
                                <p v-if="props.item.POHeader.CONumber">CO# : {{ props.item.POHeader.CONumber }}</p>
                                <p v-if="props.item.POHeader.OrderDate">Order Date : {{ props.item.POHeader.OrderDate }}
                                    <p>Address:<br>
                                        {{ props.item.POHeader.ShipToAddress1 }}<br v-if="props.item.POHeader.ShipToAddress1" />
                                        {{ props.item.POHeader.ShipToAddress2 }}<br v-if="props.item.POHeader.ShipToAddress2" />
                                        {{ props.item.POHeader.ShipToAddress3 }}<br v-if="props.item.POHeader.ShipToAddress3" />
                                        {{ props.item.POHeader.ShipToAddress4 }}<br v-if="props.item.POHeader.ShipToAddress4" />
                                        {{ props.item.POHeader.ShipToCity }}, {{ props.item.POHeader.ShipToState }} {{ props.item.POHeader.ShipToZiip }} {{ props.item.POHeader.ShipToCountry }}
                                    </p>
                                    <table class="line-item-table">
                                        <tr>
                                            <th class="text-xs-left">#</th>
                                            <th class="text-xs-left">Item</th>
                                            <th class="text-xs-left">Cust Item#</th>
                                            <th>Qty Ordered</th>
                                            <th>Release Date</th>
                                            <th>Est. Ship Date</th>
                                            <th>Qty Shipped</th>
                                            <th>Ship Date</th>
                                            <th>Carrier</th>
                                            <th>Tracking</th>
                                        </tr>
                                        <tr v-for="(line_item, key) in props.item.POLineItems" :key="key">
                                            <td class="small">{{ line_item.Line }}</td>
                                            <td class="main-field">{{ line_item.Item }}<br>{{ line_item.Description }}</td>
                                            <td class="main-field">{{ line_item.CustomerItem }}</td>
                                            <td>{{ line_item.QtyOrdered }}</td>
                                            <td>{{ formatDate(line_item.OrderDate) }}</td>
                                            <td>{{ formatDate(line_item.EstimatedShipDate, "Pending") }}</td>
                                            <td>{{ line_item.QtyShipped }}</td>
                                            <td>{{ formatDate(line_item.ShipDate) }}</td>
                                            <td>{{ line_item.Carrier }}</td>
                                            <td class="tracking-column text-xs-left">
                                                <a v-if="has_tracking_link(line_item.Carrier)" target="tracking" :href="get_tracking_link(line_item.Carrier, line_item.TrackingNumber)">{{ line_item.TrackingNumber }}</a>
                                                <span v-else-if="line_item.TrackingNumber != null">{{ line_item.TrackingNumber }}</span>
                                                <span v-else-if="pastEstimatedShipDate(line_item.EstimatedShipDate)">Contact <a href="mailto:customerservice@tutco.com">customerservice@tutco.com</a> for info.</span>
                                                <span v-else>Tracking will be available once your order has shipped.</span>
                                            </td>
                                        </tr>
                                    </table>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </template>
            </v-data-table>
        </v-card-text>
        <div class="text-xs-center pt-2" v-if="pages > 1">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
    </v-card>
</template>
<script>
const request = require('superagent');
import FieldRules from '../utils/FieldRules'
import TrackingLinks from '../utils/TrackingLinks'
export default {
    props: ['po', 'csrf', 'url'],
    data: function() {
        return {
            headers: [{
                    'text': '',
                    'value': 'id',
                    'align': 'center',
                    'width': '5px',
                    'sortable': false
                },
                {
                    'text': 'PO #',
                    'value': 'PONumber',
                    'align': 'left',
                    'width': '10px'
                },
                {
                    'text': 'Address',
                    'value': 'ShipToAddress1',
                    'align': 'left',
                },
                {
                    'text': '',
                    'sortable': false
                }
            ],
            pagination: { rowsPerPage: 10, sortBy: 'id', descending: false },
            loading: false,
            error_alert: false,
            err_msg: '',
            items: [],
            open: [1],
            po_search: null,
            rules: FieldRules,
        }
    },
    mounted() {
        if (this.po) {
            this.po_search = this.po;
            this.getData();
        }
    },
    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
            ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
        filtered_items: function() {
            if (this.items.length > 0) {
                return this.items.slice(1);
            }
            return [];
        }
    },
    methods: {
        expandItem: function(props) {
            this.ga('expand-result', this.po_search, function() {})
            props.expanded = !props.expanded
        },
        getData: function() {
            var g = this;
            this.items = [];
            this.loading = true;
            g.err_msg = '';
            g.error_alert = false;
            const { sortBy, descending, page, rowsPerPage } = this.pagination;
            g.ga('order-inquiry', this.po_search, function() {})
            request
                .post(this.url)
                .send({ po: this.po_search, _token: this.csrf })
                .then(res => {
                    if (typeof res.body.error != "undefined") {
                        g.err_msg = res.body.error;
                        g.error_alert = true;
                        g.loading = false;
                    } else {
                        g.items = res.body;
                        //g.$refs.dataTable.expanded = [true]
                        g.pagination.totalItems = g.items.length - 1;
                        g.pagination.page = 1;
                        g.loading = false;
                    }
                })
                .catch(err => {
                    console.log('catch error', err.message)
                    // err.message, err.response
                    g.err_message = err.message;
                    g.err_alert = true;
                    g.loading = false;
                });
        },
        get_tracking_link: function(carrier, tracking) {
            return TrackingLinks.getTrackingLink(carrier, tracking);
        },
        has_tracking_link: function(carrier, tracking) {
            if (typeof tracking == 'undefined' || tracking == null) {
                return false;
            }
            return TrackingLinks.getTrackingLink(carrier, '') != null;
        },
        formatDate: function(d, def) {
            if (d == null && typeof def != 'undefined') {
                return def; //the default passed for pending....
            }
            if (d != null && d != '') {
                return d.split(' ')[0];
            }
            return d;
        },
        pastEstimatedShipDate: function(est_ship_date) {
            if (typeof est_ship_date == 'undefined' || est_ship_date == null) {
                return false;
            }
            if ((new Date(est_ship_date).getTime() < new Date().getTime())) {
                return true;
            }
            return false
        },
        searchPO: function() {
            this.getData();
        },
        ga: function(action, label, callback) {
            if (typeof callback != 'function') {
                callback = function() {};
            }


            if (typeof gtag != 'undefined') {
                window.dataLayer.push({
                    event: 'ga_event',
                    event_category: 'tutco-portal',
                    event_label: label,
                    event_action: action,
                    eventCallback: callback
                });

            } else {
                callback();
            }
        },
    },
    watch: {

    }
}

</script>
<style>
.po-number {
    white-space: nowrap;
}

.tracking-column {
    min-width: 15vw;
}

</style>
